import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const PaymentApiUtils = {
  fetchCurrentPlan() {
    return xhr(ApiConstants.FetchCurrentPlan);
  },

  subscribeWithStripe(price_id) {
    return xhr(ApiConstants.ProcessSubscription + '/with-stripe', {
      method: 'post',
      body: JSON.stringify({
        price_id,
      }),
    });
  },

  confirmStripeSubscription(subscription_id) {
    return xhr(ApiConstants.ProcessSubscription + '/with-stripe/confirm', {
      method: 'post',
      body: JSON.stringify({
        subscription_id,
      }),
    });
  },

  suspend(payment_id) {
    return xhr(ApiConstants.SuspendSubscription, {
      method: 'put',
      body: JSON.stringify({
        payment_id,
      }),
    });
  },

  reactivate(payment_id) {
    return xhr(ApiConstants.ReactivateSubscription, {
      method: 'put',
      body: JSON.stringify({
        payment_id,
      }),
    });
  },

  cancel(payment_id) {
    return xhr(ApiConstants.Base + 'plan/cancel', {
      method: 'put',
      body: JSON.stringify({
        payment_id,
      }),
    });
  },

  transfer(payment_id, price_id) {
    return xhr(ApiConstants.Base + 'plan/transfer', {
      method: 'put',
      body: JSON.stringify({
        payment_id,
        price_id,
      }),
    });
  },

  renew(payment_id) {
    return xhr(ApiConstants.Base + 'plan/renew', {
      method: 'put',
      body: JSON.stringify({
        payment_id,
      }),
    });
  },

  //  PayPal Only
  setupAgreement(stripe_plan_name) {
    return xhr(ApiConstants.Base + 'paypal/agreement', {
      method: 'post',
      body: JSON.stringify({
        stripe_plan_name,
      }),
    });
  },
  // this is not for paypal rest
  // setupAgreement(planId) {
  //   const query = `?planId=${planId.toString()}`;
  //   return xhr(ApiConstants.SetupAgreement + query);
  // },
  subscribeWithPaypal(subscription_id) {
    return xhr(ApiConstants.ProcessSubscription + '/with-paypal', {
      method: 'post',
      body: JSON.stringify({
        subscription_id,
      }),
    });
  },
};

export default PaymentApiUtils;
